/**
 * Generated by the protoc-gen-ts.  DO NOT EDIT!
 * compiler version: 3.19.1
 * source: testsystem/v1/entities/test_case.proto
 * git: https://github.com/thesayyn/protoc-gen-ts */
import * as dependency_1 from "./../common/common";
import * as dependency_2 from "./../../../google/protobuf/timestamp";
import * as dependency_3 from "./../../../google/protobuf/duration";
import * as pb_1 from "google-protobuf";
export namespace testsystem.v1.entities {
    export class TestCaseRun extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            id?: string;
            name?: string;
            description?: string;
            run_id?: string;
            test_suite_id?: string;
            status?: dependency_1.testsystem.v1.common.TestStatus;
            start_time?: dependency_2.google.protobuf.Timestamp;
            end_time?: dependency_2.google.protobuf.Timestamp;
            duration?: dependency_3.google.protobuf.Duration;
            attachments?: dependency_1.testsystem.v1.common.Attachment[];
            error_message?: string;
            stack_trace?: string;
            errors?: string[];
            metadata?: Map<string, string>;
            tags?: string[];
            location?: string;
            retry_count?: number;
            retry_index?: number;
            timeout?: number;
            execution_id?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [10, 13, 15], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("id" in data && data.id != undefined) {
                    this.id = data.id;
                }
                if ("name" in data && data.name != undefined) {
                    this.name = data.name;
                }
                if ("description" in data && data.description != undefined) {
                    this.description = data.description;
                }
                if ("run_id" in data && data.run_id != undefined) {
                    this.run_id = data.run_id;
                }
                if ("test_suite_id" in data && data.test_suite_id != undefined) {
                    this.test_suite_id = data.test_suite_id;
                }
                if ("status" in data && data.status != undefined) {
                    this.status = data.status;
                }
                if ("start_time" in data && data.start_time != undefined) {
                    this.start_time = data.start_time;
                }
                if ("end_time" in data && data.end_time != undefined) {
                    this.end_time = data.end_time;
                }
                if ("duration" in data && data.duration != undefined) {
                    this.duration = data.duration;
                }
                if ("attachments" in data && data.attachments != undefined) {
                    this.attachments = data.attachments;
                }
                if ("error_message" in data && data.error_message != undefined) {
                    this.error_message = data.error_message;
                }
                if ("stack_trace" in data && data.stack_trace != undefined) {
                    this.stack_trace = data.stack_trace;
                }
                if ("errors" in data && data.errors != undefined) {
                    this.errors = data.errors;
                }
                if ("metadata" in data && data.metadata != undefined) {
                    this.metadata = data.metadata;
                }
                if ("tags" in data && data.tags != undefined) {
                    this.tags = data.tags;
                }
                if ("location" in data && data.location != undefined) {
                    this.location = data.location;
                }
                if ("retry_count" in data && data.retry_count != undefined) {
                    this.retry_count = data.retry_count;
                }
                if ("retry_index" in data && data.retry_index != undefined) {
                    this.retry_index = data.retry_index;
                }
                if ("timeout" in data && data.timeout != undefined) {
                    this.timeout = data.timeout;
                }
                if ("execution_id" in data && data.execution_id != undefined) {
                    this.execution_id = data.execution_id;
                }
            }
            if (!this.metadata)
                this.metadata = new Map();
        }
        get id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set id(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get name() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set name(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get description() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set description(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        get run_id() {
            return pb_1.Message.getFieldWithDefault(this, 4, "") as string;
        }
        set run_id(value: string) {
            pb_1.Message.setField(this, 4, value);
        }
        get test_suite_id() {
            return pb_1.Message.getFieldWithDefault(this, 5, "") as string;
        }
        set test_suite_id(value: string) {
            pb_1.Message.setField(this, 5, value);
        }
        get status() {
            return pb_1.Message.getFieldWithDefault(this, 6, dependency_1.testsystem.v1.common.TestStatus.UNKNOWN) as dependency_1.testsystem.v1.common.TestStatus;
        }
        set status(value: dependency_1.testsystem.v1.common.TestStatus) {
            pb_1.Message.setField(this, 6, value);
        }
        get start_time() {
            return pb_1.Message.getWrapperField(this, dependency_2.google.protobuf.Timestamp, 7) as dependency_2.google.protobuf.Timestamp;
        }
        set start_time(value: dependency_2.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 7, value);
        }
        get has_start_time() {
            return pb_1.Message.getField(this, 7) != null;
        }
        get end_time() {
            return pb_1.Message.getWrapperField(this, dependency_2.google.protobuf.Timestamp, 8) as dependency_2.google.protobuf.Timestamp;
        }
        set end_time(value: dependency_2.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 8, value);
        }
        get has_end_time() {
            return pb_1.Message.getField(this, 8) != null;
        }
        get duration() {
            return pb_1.Message.getWrapperField(this, dependency_3.google.protobuf.Duration, 9) as dependency_3.google.protobuf.Duration;
        }
        set duration(value: dependency_3.google.protobuf.Duration) {
            pb_1.Message.setWrapperField(this, 9, value);
        }
        get has_duration() {
            return pb_1.Message.getField(this, 9) != null;
        }
        get attachments() {
            return pb_1.Message.getRepeatedWrapperField(this, dependency_1.testsystem.v1.common.Attachment, 10) as dependency_1.testsystem.v1.common.Attachment[];
        }
        set attachments(value: dependency_1.testsystem.v1.common.Attachment[]) {
            pb_1.Message.setRepeatedWrapperField(this, 10, value);
        }
        get error_message() {
            return pb_1.Message.getFieldWithDefault(this, 11, "") as string;
        }
        set error_message(value: string) {
            pb_1.Message.setField(this, 11, value);
        }
        get stack_trace() {
            return pb_1.Message.getFieldWithDefault(this, 12, "") as string;
        }
        set stack_trace(value: string) {
            pb_1.Message.setField(this, 12, value);
        }
        get errors() {
            return pb_1.Message.getFieldWithDefault(this, 13, []) as string[];
        }
        set errors(value: string[]) {
            pb_1.Message.setField(this, 13, value);
        }
        get metadata() {
            return pb_1.Message.getField(this, 14) as any as Map<string, string>;
        }
        set metadata(value: Map<string, string>) {
            pb_1.Message.setField(this, 14, value as any);
        }
        get tags() {
            return pb_1.Message.getFieldWithDefault(this, 15, []) as string[];
        }
        set tags(value: string[]) {
            pb_1.Message.setField(this, 15, value);
        }
        get location() {
            return pb_1.Message.getFieldWithDefault(this, 16, "") as string;
        }
        set location(value: string) {
            pb_1.Message.setField(this, 16, value);
        }
        get retry_count() {
            return pb_1.Message.getFieldWithDefault(this, 17, 0) as number;
        }
        set retry_count(value: number) {
            pb_1.Message.setField(this, 17, value);
        }
        get retry_index() {
            return pb_1.Message.getFieldWithDefault(this, 18, 0) as number;
        }
        set retry_index(value: number) {
            pb_1.Message.setField(this, 18, value);
        }
        get timeout() {
            return pb_1.Message.getFieldWithDefault(this, 19, 0) as number;
        }
        set timeout(value: number) {
            pb_1.Message.setField(this, 19, value);
        }
        get execution_id() {
            return pb_1.Message.getFieldWithDefault(this, 20, "") as string;
        }
        set execution_id(value: string) {
            pb_1.Message.setField(this, 20, value);
        }
        static fromObject(data: {
            id?: string;
            name?: string;
            description?: string;
            run_id?: string;
            test_suite_id?: string;
            status?: dependency_1.testsystem.v1.common.TestStatus;
            start_time?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
            end_time?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
            duration?: ReturnType<typeof dependency_3.google.protobuf.Duration.prototype.toObject>;
            attachments?: ReturnType<typeof dependency_1.testsystem.v1.common.Attachment.prototype.toObject>[];
            error_message?: string;
            stack_trace?: string;
            errors?: string[];
            metadata?: {
                [key: string]: string;
            };
            tags?: string[];
            location?: string;
            retry_count?: number;
            retry_index?: number;
            timeout?: number;
            execution_id?: string;
        }): TestCaseRun {
            const message = new TestCaseRun({});
            if (data.id != null) {
                message.id = data.id;
            }
            if (data.name != null) {
                message.name = data.name;
            }
            if (data.description != null) {
                message.description = data.description;
            }
            if (data.run_id != null) {
                message.run_id = data.run_id;
            }
            if (data.test_suite_id != null) {
                message.test_suite_id = data.test_suite_id;
            }
            if (data.status != null) {
                message.status = data.status;
            }
            if (data.start_time != null) {
                message.start_time = dependency_2.google.protobuf.Timestamp.fromObject(data.start_time);
            }
            if (data.end_time != null) {
                message.end_time = dependency_2.google.protobuf.Timestamp.fromObject(data.end_time);
            }
            if (data.duration != null) {
                message.duration = dependency_3.google.protobuf.Duration.fromObject(data.duration);
            }
            if (data.attachments != null) {
                message.attachments = data.attachments.map(item => dependency_1.testsystem.v1.common.Attachment.fromObject(item));
            }
            if (data.error_message != null) {
                message.error_message = data.error_message;
            }
            if (data.stack_trace != null) {
                message.stack_trace = data.stack_trace;
            }
            if (data.errors != null) {
                message.errors = data.errors;
            }
            if (typeof data.metadata == "object") {
                message.metadata = new Map(Object.entries(data.metadata));
            }
            if (data.tags != null) {
                message.tags = data.tags;
            }
            if (data.location != null) {
                message.location = data.location;
            }
            if (data.retry_count != null) {
                message.retry_count = data.retry_count;
            }
            if (data.retry_index != null) {
                message.retry_index = data.retry_index;
            }
            if (data.timeout != null) {
                message.timeout = data.timeout;
            }
            if (data.execution_id != null) {
                message.execution_id = data.execution_id;
            }
            return message;
        }
        toObject() {
            const data: {
                id?: string;
                name?: string;
                description?: string;
                run_id?: string;
                test_suite_id?: string;
                status?: dependency_1.testsystem.v1.common.TestStatus;
                start_time?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
                end_time?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
                duration?: ReturnType<typeof dependency_3.google.protobuf.Duration.prototype.toObject>;
                attachments?: ReturnType<typeof dependency_1.testsystem.v1.common.Attachment.prototype.toObject>[];
                error_message?: string;
                stack_trace?: string;
                errors?: string[];
                metadata?: {
                    [key: string]: string;
                };
                tags?: string[];
                location?: string;
                retry_count?: number;
                retry_index?: number;
                timeout?: number;
                execution_id?: string;
            } = {};
            if (this.id != null) {
                data.id = this.id;
            }
            if (this.name != null) {
                data.name = this.name;
            }
            if (this.description != null) {
                data.description = this.description;
            }
            if (this.run_id != null) {
                data.run_id = this.run_id;
            }
            if (this.test_suite_id != null) {
                data.test_suite_id = this.test_suite_id;
            }
            if (this.status != null) {
                data.status = this.status;
            }
            if (this.start_time != null) {
                data.start_time = this.start_time.toObject();
            }
            if (this.end_time != null) {
                data.end_time = this.end_time.toObject();
            }
            if (this.duration != null) {
                data.duration = this.duration.toObject();
            }
            if (this.attachments != null) {
                data.attachments = this.attachments.map((item: dependency_1.testsystem.v1.common.Attachment) => item.toObject());
            }
            if (this.error_message != null) {
                data.error_message = this.error_message;
            }
            if (this.stack_trace != null) {
                data.stack_trace = this.stack_trace;
            }
            if (this.errors != null) {
                data.errors = this.errors;
            }
            if (this.metadata != null) {
                data.metadata = (Object.fromEntries)(this.metadata);
            }
            if (this.tags != null) {
                data.tags = this.tags;
            }
            if (this.location != null) {
                data.location = this.location;
            }
            if (this.retry_count != null) {
                data.retry_count = this.retry_count;
            }
            if (this.retry_index != null) {
                data.retry_index = this.retry_index;
            }
            if (this.timeout != null) {
                data.timeout = this.timeout;
            }
            if (this.execution_id != null) {
                data.execution_id = this.execution_id;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.id.length)
                writer.writeString(1, this.id);
            if (this.name.length)
                writer.writeString(2, this.name);
            if (this.description.length)
                writer.writeString(3, this.description);
            if (this.run_id.length)
                writer.writeString(4, this.run_id);
            if (this.test_suite_id.length)
                writer.writeString(5, this.test_suite_id);
            if (this.status != dependency_1.testsystem.v1.common.TestStatus.UNKNOWN)
                writer.writeEnum(6, this.status);
            if (this.has_start_time)
                writer.writeMessage(7, this.start_time, () => this.start_time.serialize(writer));
            if (this.has_end_time)
                writer.writeMessage(8, this.end_time, () => this.end_time.serialize(writer));
            if (this.has_duration)
                writer.writeMessage(9, this.duration, () => this.duration.serialize(writer));
            if (this.attachments.length)
                writer.writeRepeatedMessage(10, this.attachments, (item: dependency_1.testsystem.v1.common.Attachment) => item.serialize(writer));
            if (this.error_message.length)
                writer.writeString(11, this.error_message);
            if (this.stack_trace.length)
                writer.writeString(12, this.stack_trace);
            if (this.errors.length)
                writer.writeRepeatedString(13, this.errors);
            for (const [key, value] of this.metadata) {
                writer.writeMessage(14, this.metadata, () => {
                    writer.writeString(1, key);
                    writer.writeString(2, value);
                });
            }
            if (this.tags.length)
                writer.writeRepeatedString(15, this.tags);
            if (this.location.length)
                writer.writeString(16, this.location);
            if (this.retry_count != 0)
                writer.writeInt32(17, this.retry_count);
            if (this.retry_index != 0)
                writer.writeInt32(18, this.retry_index);
            if (this.timeout != 0)
                writer.writeInt32(19, this.timeout);
            if (this.execution_id.length)
                writer.writeString(20, this.execution_id);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): TestCaseRun {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new TestCaseRun();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.id = reader.readString();
                        break;
                    case 2:
                        message.name = reader.readString();
                        break;
                    case 3:
                        message.description = reader.readString();
                        break;
                    case 4:
                        message.run_id = reader.readString();
                        break;
                    case 5:
                        message.test_suite_id = reader.readString();
                        break;
                    case 6:
                        message.status = reader.readEnum();
                        break;
                    case 7:
                        reader.readMessage(message.start_time, () => message.start_time = dependency_2.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 8:
                        reader.readMessage(message.end_time, () => message.end_time = dependency_2.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 9:
                        reader.readMessage(message.duration, () => message.duration = dependency_3.google.protobuf.Duration.deserialize(reader));
                        break;
                    case 10:
                        reader.readMessage(message.attachments, () => pb_1.Message.addToRepeatedWrapperField(message, 10, dependency_1.testsystem.v1.common.Attachment.deserialize(reader), dependency_1.testsystem.v1.common.Attachment));
                        break;
                    case 11:
                        message.error_message = reader.readString();
                        break;
                    case 12:
                        message.stack_trace = reader.readString();
                        break;
                    case 13:
                        pb_1.Message.addToRepeatedField(message, 13, reader.readString());
                        break;
                    case 14:
                        reader.readMessage(message, () => pb_1.Map.deserializeBinary(message.metadata as any, reader, reader.readString, reader.readString));
                        break;
                    case 15:
                        pb_1.Message.addToRepeatedField(message, 15, reader.readString());
                        break;
                    case 16:
                        message.location = reader.readString();
                        break;
                    case 17:
                        message.retry_count = reader.readInt32();
                        break;
                    case 18:
                        message.retry_index = reader.readInt32();
                        break;
                    case 19:
                        message.timeout = reader.readInt32();
                        break;
                    case 20:
                        message.execution_id = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static deserializeBinary(bytes: Uint8Array): TestCaseRun {
            return TestCaseRun.deserialize(bytes);
        }
    }
    export class StepRun extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            id?: string;
            run_id?: string;
            test_case_id?: string;
            title?: string;
            description?: string;
            start_time?: dependency_2.google.protobuf.Timestamp;
            duration?: dependency_3.google.protobuf.Duration;
            type?: string;
            metadata?: Map<string, string>;
            parent_step_id?: string;
            worker_index?: string;
            status?: dependency_1.testsystem.v1.common.TestStatus;
            error?: string;
            errors?: string[];
            location?: string;
            category?: string;
            retry_index?: number;
            attachments?: dependency_1.testsystem.v1.common.Attachment[];
            execution_id?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [14, 18], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("id" in data && data.id != undefined) {
                    this.id = data.id;
                }
                if ("run_id" in data && data.run_id != undefined) {
                    this.run_id = data.run_id;
                }
                if ("test_case_id" in data && data.test_case_id != undefined) {
                    this.test_case_id = data.test_case_id;
                }
                if ("title" in data && data.title != undefined) {
                    this.title = data.title;
                }
                if ("description" in data && data.description != undefined) {
                    this.description = data.description;
                }
                if ("start_time" in data && data.start_time != undefined) {
                    this.start_time = data.start_time;
                }
                if ("duration" in data && data.duration != undefined) {
                    this.duration = data.duration;
                }
                if ("type" in data && data.type != undefined) {
                    this.type = data.type;
                }
                if ("metadata" in data && data.metadata != undefined) {
                    this.metadata = data.metadata;
                }
                if ("parent_step_id" in data && data.parent_step_id != undefined) {
                    this.parent_step_id = data.parent_step_id;
                }
                if ("worker_index" in data && data.worker_index != undefined) {
                    this.worker_index = data.worker_index;
                }
                if ("status" in data && data.status != undefined) {
                    this.status = data.status;
                }
                if ("error" in data && data.error != undefined) {
                    this.error = data.error;
                }
                if ("errors" in data && data.errors != undefined) {
                    this.errors = data.errors;
                }
                if ("location" in data && data.location != undefined) {
                    this.location = data.location;
                }
                if ("category" in data && data.category != undefined) {
                    this.category = data.category;
                }
                if ("retry_index" in data && data.retry_index != undefined) {
                    this.retry_index = data.retry_index;
                }
                if ("attachments" in data && data.attachments != undefined) {
                    this.attachments = data.attachments;
                }
                if ("execution_id" in data && data.execution_id != undefined) {
                    this.execution_id = data.execution_id;
                }
            }
            if (!this.metadata)
                this.metadata = new Map();
        }
        get id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set id(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get run_id() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set run_id(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get test_case_id() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set test_case_id(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        get title() {
            return pb_1.Message.getFieldWithDefault(this, 4, "") as string;
        }
        set title(value: string) {
            pb_1.Message.setField(this, 4, value);
        }
        get description() {
            return pb_1.Message.getFieldWithDefault(this, 5, "") as string;
        }
        set description(value: string) {
            pb_1.Message.setField(this, 5, value);
        }
        get start_time() {
            return pb_1.Message.getWrapperField(this, dependency_2.google.protobuf.Timestamp, 6) as dependency_2.google.protobuf.Timestamp;
        }
        set start_time(value: dependency_2.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 6, value);
        }
        get has_start_time() {
            return pb_1.Message.getField(this, 6) != null;
        }
        get duration() {
            return pb_1.Message.getWrapperField(this, dependency_3.google.protobuf.Duration, 7) as dependency_3.google.protobuf.Duration;
        }
        set duration(value: dependency_3.google.protobuf.Duration) {
            pb_1.Message.setWrapperField(this, 7, value);
        }
        get has_duration() {
            return pb_1.Message.getField(this, 7) != null;
        }
        get type() {
            return pb_1.Message.getFieldWithDefault(this, 8, "") as string;
        }
        set type(value: string) {
            pb_1.Message.setField(this, 8, value);
        }
        get metadata() {
            return pb_1.Message.getField(this, 9) as any as Map<string, string>;
        }
        set metadata(value: Map<string, string>) {
            pb_1.Message.setField(this, 9, value as any);
        }
        get parent_step_id() {
            return pb_1.Message.getFieldWithDefault(this, 10, "") as string;
        }
        set parent_step_id(value: string) {
            pb_1.Message.setField(this, 10, value);
        }
        get worker_index() {
            return pb_1.Message.getFieldWithDefault(this, 11, "") as string;
        }
        set worker_index(value: string) {
            pb_1.Message.setField(this, 11, value);
        }
        get status() {
            return pb_1.Message.getFieldWithDefault(this, 12, dependency_1.testsystem.v1.common.TestStatus.UNKNOWN) as dependency_1.testsystem.v1.common.TestStatus;
        }
        set status(value: dependency_1.testsystem.v1.common.TestStatus) {
            pb_1.Message.setField(this, 12, value);
        }
        get error() {
            return pb_1.Message.getFieldWithDefault(this, 13, "") as string;
        }
        set error(value: string) {
            pb_1.Message.setField(this, 13, value);
        }
        get errors() {
            return pb_1.Message.getFieldWithDefault(this, 14, []) as string[];
        }
        set errors(value: string[]) {
            pb_1.Message.setField(this, 14, value);
        }
        get location() {
            return pb_1.Message.getFieldWithDefault(this, 15, "") as string;
        }
        set location(value: string) {
            pb_1.Message.setField(this, 15, value);
        }
        get category() {
            return pb_1.Message.getFieldWithDefault(this, 16, "") as string;
        }
        set category(value: string) {
            pb_1.Message.setField(this, 16, value);
        }
        get retry_index() {
            return pb_1.Message.getFieldWithDefault(this, 17, 0) as number;
        }
        set retry_index(value: number) {
            pb_1.Message.setField(this, 17, value);
        }
        get attachments() {
            return pb_1.Message.getRepeatedWrapperField(this, dependency_1.testsystem.v1.common.Attachment, 18) as dependency_1.testsystem.v1.common.Attachment[];
        }
        set attachments(value: dependency_1.testsystem.v1.common.Attachment[]) {
            pb_1.Message.setRepeatedWrapperField(this, 18, value);
        }
        get execution_id() {
            return pb_1.Message.getFieldWithDefault(this, 19, "") as string;
        }
        set execution_id(value: string) {
            pb_1.Message.setField(this, 19, value);
        }
        static fromObject(data: {
            id?: string;
            run_id?: string;
            test_case_id?: string;
            title?: string;
            description?: string;
            start_time?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
            duration?: ReturnType<typeof dependency_3.google.protobuf.Duration.prototype.toObject>;
            type?: string;
            metadata?: {
                [key: string]: string;
            };
            parent_step_id?: string;
            worker_index?: string;
            status?: dependency_1.testsystem.v1.common.TestStatus;
            error?: string;
            errors?: string[];
            location?: string;
            category?: string;
            retry_index?: number;
            attachments?: ReturnType<typeof dependency_1.testsystem.v1.common.Attachment.prototype.toObject>[];
            execution_id?: string;
        }): StepRun {
            const message = new StepRun({});
            if (data.id != null) {
                message.id = data.id;
            }
            if (data.run_id != null) {
                message.run_id = data.run_id;
            }
            if (data.test_case_id != null) {
                message.test_case_id = data.test_case_id;
            }
            if (data.title != null) {
                message.title = data.title;
            }
            if (data.description != null) {
                message.description = data.description;
            }
            if (data.start_time != null) {
                message.start_time = dependency_2.google.protobuf.Timestamp.fromObject(data.start_time);
            }
            if (data.duration != null) {
                message.duration = dependency_3.google.protobuf.Duration.fromObject(data.duration);
            }
            if (data.type != null) {
                message.type = data.type;
            }
            if (typeof data.metadata == "object") {
                message.metadata = new Map(Object.entries(data.metadata));
            }
            if (data.parent_step_id != null) {
                message.parent_step_id = data.parent_step_id;
            }
            if (data.worker_index != null) {
                message.worker_index = data.worker_index;
            }
            if (data.status != null) {
                message.status = data.status;
            }
            if (data.error != null) {
                message.error = data.error;
            }
            if (data.errors != null) {
                message.errors = data.errors;
            }
            if (data.location != null) {
                message.location = data.location;
            }
            if (data.category != null) {
                message.category = data.category;
            }
            if (data.retry_index != null) {
                message.retry_index = data.retry_index;
            }
            if (data.attachments != null) {
                message.attachments = data.attachments.map(item => dependency_1.testsystem.v1.common.Attachment.fromObject(item));
            }
            if (data.execution_id != null) {
                message.execution_id = data.execution_id;
            }
            return message;
        }
        toObject() {
            const data: {
                id?: string;
                run_id?: string;
                test_case_id?: string;
                title?: string;
                description?: string;
                start_time?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
                duration?: ReturnType<typeof dependency_3.google.protobuf.Duration.prototype.toObject>;
                type?: string;
                metadata?: {
                    [key: string]: string;
                };
                parent_step_id?: string;
                worker_index?: string;
                status?: dependency_1.testsystem.v1.common.TestStatus;
                error?: string;
                errors?: string[];
                location?: string;
                category?: string;
                retry_index?: number;
                attachments?: ReturnType<typeof dependency_1.testsystem.v1.common.Attachment.prototype.toObject>[];
                execution_id?: string;
            } = {};
            if (this.id != null) {
                data.id = this.id;
            }
            if (this.run_id != null) {
                data.run_id = this.run_id;
            }
            if (this.test_case_id != null) {
                data.test_case_id = this.test_case_id;
            }
            if (this.title != null) {
                data.title = this.title;
            }
            if (this.description != null) {
                data.description = this.description;
            }
            if (this.start_time != null) {
                data.start_time = this.start_time.toObject();
            }
            if (this.duration != null) {
                data.duration = this.duration.toObject();
            }
            if (this.type != null) {
                data.type = this.type;
            }
            if (this.metadata != null) {
                data.metadata = (Object.fromEntries)(this.metadata);
            }
            if (this.parent_step_id != null) {
                data.parent_step_id = this.parent_step_id;
            }
            if (this.worker_index != null) {
                data.worker_index = this.worker_index;
            }
            if (this.status != null) {
                data.status = this.status;
            }
            if (this.error != null) {
                data.error = this.error;
            }
            if (this.errors != null) {
                data.errors = this.errors;
            }
            if (this.location != null) {
                data.location = this.location;
            }
            if (this.category != null) {
                data.category = this.category;
            }
            if (this.retry_index != null) {
                data.retry_index = this.retry_index;
            }
            if (this.attachments != null) {
                data.attachments = this.attachments.map((item: dependency_1.testsystem.v1.common.Attachment) => item.toObject());
            }
            if (this.execution_id != null) {
                data.execution_id = this.execution_id;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.id.length)
                writer.writeString(1, this.id);
            if (this.run_id.length)
                writer.writeString(2, this.run_id);
            if (this.test_case_id.length)
                writer.writeString(3, this.test_case_id);
            if (this.title.length)
                writer.writeString(4, this.title);
            if (this.description.length)
                writer.writeString(5, this.description);
            if (this.has_start_time)
                writer.writeMessage(6, this.start_time, () => this.start_time.serialize(writer));
            if (this.has_duration)
                writer.writeMessage(7, this.duration, () => this.duration.serialize(writer));
            if (this.type.length)
                writer.writeString(8, this.type);
            for (const [key, value] of this.metadata) {
                writer.writeMessage(9, this.metadata, () => {
                    writer.writeString(1, key);
                    writer.writeString(2, value);
                });
            }
            if (this.parent_step_id.length)
                writer.writeString(10, this.parent_step_id);
            if (this.worker_index.length)
                writer.writeString(11, this.worker_index);
            if (this.status != dependency_1.testsystem.v1.common.TestStatus.UNKNOWN)
                writer.writeEnum(12, this.status);
            if (this.error.length)
                writer.writeString(13, this.error);
            if (this.errors.length)
                writer.writeRepeatedString(14, this.errors);
            if (this.location.length)
                writer.writeString(15, this.location);
            if (this.category.length)
                writer.writeString(16, this.category);
            if (this.retry_index != 0)
                writer.writeInt32(17, this.retry_index);
            if (this.attachments.length)
                writer.writeRepeatedMessage(18, this.attachments, (item: dependency_1.testsystem.v1.common.Attachment) => item.serialize(writer));
            if (this.execution_id.length)
                writer.writeString(19, this.execution_id);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): StepRun {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new StepRun();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.id = reader.readString();
                        break;
                    case 2:
                        message.run_id = reader.readString();
                        break;
                    case 3:
                        message.test_case_id = reader.readString();
                        break;
                    case 4:
                        message.title = reader.readString();
                        break;
                    case 5:
                        message.description = reader.readString();
                        break;
                    case 6:
                        reader.readMessage(message.start_time, () => message.start_time = dependency_2.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 7:
                        reader.readMessage(message.duration, () => message.duration = dependency_3.google.protobuf.Duration.deserialize(reader));
                        break;
                    case 8:
                        message.type = reader.readString();
                        break;
                    case 9:
                        reader.readMessage(message, () => pb_1.Map.deserializeBinary(message.metadata as any, reader, reader.readString, reader.readString));
                        break;
                    case 10:
                        message.parent_step_id = reader.readString();
                        break;
                    case 11:
                        message.worker_index = reader.readString();
                        break;
                    case 12:
                        message.status = reader.readEnum();
                        break;
                    case 13:
                        message.error = reader.readString();
                        break;
                    case 14:
                        pb_1.Message.addToRepeatedField(message, 14, reader.readString());
                        break;
                    case 15:
                        message.location = reader.readString();
                        break;
                    case 16:
                        message.category = reader.readString();
                        break;
                    case 17:
                        message.retry_index = reader.readInt32();
                        break;
                    case 18:
                        reader.readMessage(message.attachments, () => pb_1.Message.addToRepeatedWrapperField(message, 18, dependency_1.testsystem.v1.common.Attachment.deserialize(reader), dependency_1.testsystem.v1.common.Attachment));
                        break;
                    case 19:
                        message.execution_id = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static deserializeBinary(bytes: Uint8Array): StepRun {
            return StepRun.deserialize(bytes);
        }
    }
}
